import React, { useState } from 'react';
import { View, StyleSheet, Image, TouchableOpacity } from 'react-native';
import { DataGrid, DataGridColumn, BText, Page, BLink } from '../../../components';
import {
  dayLeftFromToday,
  formatDateOfYear,
  formatDayOfYear,
  formatMonthOfYear,
  formatYearOfYear,
} from '../../../utils/dateUtils';
import eventListingJson from '../../../assets/data/eventListing.json';
import eventIcon from '../../../assets/images/event_thumbnail_icon.png';
import { numberWithCommas } from '../../../utils/helper';

export const AdminEventManagement = ({ navigation }: any) => {
  const [states] = useState(eventListingJson);

  const column: DataGridColumn[] = [
    {
      label: 'Event',
      key: 'eventName',
      columnWidth: '40%',
      sortable: true,
      dataType: 'text',
      cellRender: (item: any) => renderEventItem(item),
    },
    {
      label: 'Sold (Unit)',
      key: 'numberOfTicketsSold',
      columnWidth: '20%',
      sortable: true,
      dataType: 'text',
      cellRender: (item: any) => renderEventSoldItem(item),
    },
    {
      label: 'Gross (RM)',
      headerAlign: 'flex-end',
      key: 'numberOfTickets',
      columnWidth: '10%',
      sortable: true,
      dataType: 'number',
      cellRender: (item: any) => renderEventGrossItem(item),
    },
    {
      label: 'Status',
      headerAlign: 'flex-end',
      key: 'status',
      columnWidth: '15%',
      sortable: true,
      cellRender: (item: any) => renderEventStatusItem(item),
    },
    {
      label: 'Action',
      headerAlign: 'center',
      key: '',
      columnWidth: '15%',
      sortable: false,
      cellRender: (item: any) => renderActionButtonItem(item),
    },
  ];

  const renderEventItem = (item: any) => {
    return (
      <View style={styles.eventContainer}>
        <View style={styles.eventDateContainer}>
          <View style={{ flexDirection: 'row' }}>
            <BText style={styles.eventDateText}>{formatDayOfYear(item.eventDate.start)}, </BText>
            <BText style={styles.eventDateText}>{formatDateOfYear(item.eventDate.start)}</BText>
          </View>
          <BText style={styles.eventMonthText}>{formatMonthOfYear(item.eventDate.start)}</BText>
          <BText style={styles.eventYearText}>{formatYearOfYear(item.eventDate.start)}</BText>
        </View>
        <Image source={{ uri: eventIcon }} style={styles.eventIconContainer} />
        <View style={styles.eventNameVenueDateContainer}>
          <BText style={styles.eventNameText} ellipsizeMode="tail" numberOfLines={1}>
            {item.eventName}
          </BText>
          <BText style={styles.eventDescriptionText} ellipsizeMode="tail" numberOfLines={1}>
            {item.eventDescription}
          </BText>
          <BText style={styles.eventDescriptionText} ellipsizeMode="tail" numberOfLines={1}>
            {dayLeftFromToday(item.eventDate.start)}
          </BText>
        </View>
      </View>
    );
  };

  const renderEventSoldItem = (item: any) => {
    return (
      <View style={styles.eventSoldContainer}>
        <BText>{`${item.numberOfTicketsSold} / ${item.numberOfTickets}`}</BText>
        <View style={styles.progressBarContainer}>
          <View
            style={[styles.progressBar, { width: `${(item.numberOfTicketsSold / item.numberOfTickets) * 100}%` }]}
          />
          <View style={styles.overlayTextContainer}>
            <BText style={styles.overlayText}>{(item.numberOfTicketsSold / item.numberOfTickets) * 100}%</BText>
          </View>
        </View>
      </View>
    );
  };

  const renderEventGrossItem = (item: any) => {
    return (
      <View style={{ alignItems: 'flex-end' }}>
        <BText>{`${numberWithCommas(item.numberOfTicketsSold * item.eventPrice)}`}</BText>
      </View>
    );
  };

  const renderEventStatusItem = (item: any) => {
    return (
      <View style={{ alignItems: 'flex-end' }}>
        <BText
          style={{
            fontSize: 13,
            fontWeight: 'bold',
            backgroundColor: getStatusTextColor(item),
            borderRadius: 20,
            paddingStart: 10,
            paddingEnd: 10,
            paddingTop: 5,
            paddingBottom: 5,
          }}
        >{`${item.status}`}</BText>
      </View>
    );
  };

  const renderActionButtonItem = (item: any) => {
    return (
      <View style={{ alignItems: 'center' }}>
        <TouchableOpacity style={styles.eventSelectContainer}>
          <BLink to={{ screen: 'event-details-management', params: { eventId: item._id } }}>
            <BText style={styles.eventSelectButton}>Details</BText>
          </BLink>
        </TouchableOpacity>
      </View>
    );
  };

  const getStatusTextColor = (item: any) => {
    let color;
    if (item.status === 'Active') color = '#64FFBE';
    else if (item.status === 'Draft') color = '#FFF164';
    else if (item.status === 'Ended') color = '#FF6464';
    else if (item.status === 'Scheduled') color = '#6655FF';
    else color = 'black';
    return color;
  };

  const handelCreateEvent = () => {
    // <BLink to={{ screen: 'event-details-management', params: { eventId: '0'} }}>
    //   {/* <BText style={styles.eventSelectButton}>Details</BText> */}
    // </BLink>
    navigation.navigate('event-details-management', {
      eventId: '0',
    });
  };

  return (
    <Page title={'Task Management'}>
      <View>
        <DataGrid
          data={states}
          columns={column}
          defaultSort={{ key: 'eventName', direction: 'ascending' }}
          primaryButton={{
            label: 'Create Task',
            action: () => handelCreateEvent(),
          }}
        />
      </View>
    </Page>
  );
};

const styles = StyleSheet.create({
  eventContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  eventNameContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  eventNameText: {
    fontSize: 15,
    fontWeight: 'bold',
  },
  eventDescriptionText: {
    fontSize: 12,
    fontWeight: 'bold',
    color: 'grey',
  },
  eventDateText: {
    fontSize: 13,
    color: 'black',
    fontWeight: 'bold',
  },
  eventMonthText: {
    fontSize: 20,
    color: 'red',
    fontWeight: 'bold',
  },
  eventYearText: {
    fontSize: 18,
    color: 'black',
    fontWeight: 'bold',
  },
  eventDateContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  eventNameVenueDateContainer: {
    flex: 1,
    flexDirection: 'column',
  },
  eventIconContainer: {
    height: 50,
    width: 50,
    marginStart: 10,
    marginEnd: 10,
  },
  progressBarContainer: {
    width: '70%',
    height: 15,
    backgroundColor: '#ccc',
    borderRadius: 10,
    overflow: 'hidden',
  },
  progressBar: {
    height: 15,
    backgroundColor: 'green',
  },
  progressText: {
    marginTop: 10,
    fontSize: 20,
  },
  eventSoldContainer: {
    flexDirection: 'column',
  },
  eventStatusText: {
    fontSize: 13,
    color: '',
  },
  overlayTextContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  overlayText: {
    fontSize: 11,
    color: 'white', // Customize the color as needed
  },
  eventActiinContainer: {
    flexDirection: 'column',
  },
  eventSelectContainer: {
    width: '40%',
    alignItems: 'center',
    backgroundColor: 'black',
    borderRadius: 10,
    padding: 5,
    justifyContent: 'center',
  },
  eventSelectButton: {
    fontSize: 12,
    color: 'white',
    fontWeight: 'bold',
  },
});
